/*
  Siltcon Auréa: de winkelwagenlade en de winkelwagenpagina.

  - Een koopformulier (action /cart/add) wordt onderschept: toevoegen via /cart/add.js, daarna opent de lade
    en blijft de klant op de productpagina.
  - Aantal, verwijderen, bandjesset toevoegen en kortingscodes gaan via de Ajax API van Shopify.
  - In het aanbod "Tweede horloge 40% korting" kiest de klant een kleur; de knop Toevoegen voegt die variant toe.
  - Na elke wijziging wordt /?sections=aurea-wagen opgehaald en het deel [data-aurea-wagen-rest] overgezet,
    in de lade en op de pagina. Het aantal in de kop en het mandje in de header worden bijgewerkt.
  - Het mandje in de header opent de lade als die op de pagina staat.
*/
(() => {
  if (window.aureaWagen) return;

  const lade = () => document.querySelector('[data-aurea-wagen-lade]');
  let sluitTimer = 0;

  const open = () => {
    const l = lade();
    if (!l) return;
    clearTimeout(sluitTimer);
    l.hidden = false;
    document.documentElement.classList.add('aurea-wagen-open');
    requestAnimationFrame(() => {
      l.classList.add('is-open');
      const knop = l.querySelector('[data-aurea-wagen-sluit-knop]') || l.querySelector('.aurea-wagen-lade__paneel');
      if (knop) knop.focus({ preventScroll: true });
    });
  };

  const sluit = () => {
    const l = lade();
    if (!l) return;
    l.classList.remove('is-open');
    document.documentElement.classList.remove('aurea-wagen-open');
    sluitTimer = setTimeout(() => {
      if (!l.classList.contains('is-open')) l.hidden = true;
    }, 320);
  };

  const isOpen = () => {
    const l = lade();
    return !!l && l.classList.contains('is-open');
  };

  const bubbel = (aantal) => {
    document.querySelectorAll('.cart-bubble').forEach((b) => {
      b.classList.toggle('visually-hidden', aantal === 0);
      const teller = b.querySelector('.cart-bubble__text-count');
      if (teller) {
        teller.textContent = String(aantal);
        teller.classList.toggle('hidden', aantal === 0);
      }
    });
    document.querySelectorAll('.header-actions__cart-icon').forEach((i) => {
      i.classList.toggle('header-actions__cart-icon--has-cart', aantal > 0);
    });
  };

  const melding = (tekst) => {
    let el = document.querySelector('[data-aurea-wagen-melding]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-aurea-wagen-melding', '');
      el.setAttribute('role', 'status');
      el.style.cssText =
        'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:1300;max-width:calc(100% - 32px);padding:12px 18px;border-radius:12px;background:#2b2523;color:#f7f1e8;font-size:15px;line-height:1.4;box-shadow:0 8px 24px rgba(43,37,35,.25)';
      document.body.appendChild(el);
    }
    el.textContent = tekst;
    el.hidden = false;
    clearTimeout(el._timer);
    el._timer = setTimeout(() => {
      el.hidden = true;
    }, 4000);
  };

  const post = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });

  /** Haalt de sectie opnieuw op en zet de inhoud over, in de lade en op de pagina. */
  const vernieuw = async () => {
    const r = await fetch('/?sections=aurea-wagen', { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('Winkelwagen ophalen is niet gelukt (' + r.status + ')');
    const j = await r.json();
    const doc = new DOMParser().parseFromString(j['aurea-wagen'] || '', 'text/html');
    const nieuw = doc.querySelector('[data-aurea-wagen-inhoud]');
    if (!nieuw) throw new Error('Geen winkelwageninhoud in het antwoord');
    document.querySelectorAll('[data-aurea-wagen-inhoud]').forEach((el) => {
      const rest = el.querySelector('[data-aurea-wagen-rest]');
      const nieuwRest = nieuw.querySelector('[data-aurea-wagen-rest]');
      if (rest && nieuwRest) rest.replaceWith(nieuwRest.cloneNode(true));
      const tekst = el.querySelector('[data-aurea-wagen-aantal-tekst]');
      const nieuwTekst = nieuw.querySelector('[data-aurea-wagen-aantal-tekst]');
      if (tekst && nieuwTekst) tekst.textContent = nieuwTekst.textContent;
      el.dataset.aantal = nieuw.dataset.aantal || '0';
      el.dataset.totaal = nieuw.dataset.totaal || '0';
    });
    bubbel(parseInt(nieuw.dataset.aantal || '0', 10));
    if (typeof window.aureaLeverWerkBij === 'function') window.aureaLeverWerkBij();
    document.dispatchEvent(new CustomEvent('aurea-wagen:vernieuwd', { detail: { aantal: parseInt(nieuw.dataset.aantal || '0', 10) } }));
  };

  const bezig = (el, aan) => {
    if (el) el.classList.toggle('is-bezig', aan);
  };

  const huidigeCodes = () =>
    [...document.querySelectorAll('[data-aurea-wagen-code-weg]')]
      .map((b) => b.getAttribute('data-aurea-wagen-code-weg') || '')
      .filter(Boolean)
      .filter((c, i, lijst) => lijst.findIndex((x) => x.toLowerCase() === c.toLowerCase()) === i);

  const toonCodeFout = (tekst) => {
    document.querySelectorAll('[data-aurea-wagen-code-blok]').forEach((blok) => {
      blok.open = true;
      const fout = blok.querySelector('[data-aurea-wagen-code-fout]');
      if (fout) {
        fout.textContent = tekst;
        fout.hidden = false;
      }
    });
  };

  /** Past een kortingscode toe via /cart/update.js. Een code die niet geldt wordt weer weggehaald. */
  const codeToepassen = async (form) => {
    const invoer = form.querySelector('input[name="discount"]');
    const code = (invoer && invoer.value.trim()) || '';
    if (!code) return;
    const bestaand = huidigeCodes();
    if (bestaand.some((c) => c.toLowerCase() === code.toLowerCase())) return;
    bezig(form, true);
    try {
      const r = await post('/cart/update.js', { discount: [...bestaand, code].join(',') });
      const j = await r.json().catch(() => ({}));
      const nietGeldig =
        !r.ok ||
        (Array.isArray(j.discount_codes) &&
          j.discount_codes.some((d) => d.code.toLowerCase() === code.toLowerCase() && d.applicable === false));
      if (nietGeldig) {
        await post('/cart/update.js', { discount: bestaand.join(',') });
        await vernieuw();
        toonCodeFout('Deze code is niet geldig.');
        return;
      }
      await vernieuw();
    } finally {
      bezig(form, false);
    }
  };

  /** Zet een FormData om naar x-www-form-urlencoded, zoals een gewoon formulier. */
  const formulierData = (form) => {
    const params = new URLSearchParams();
    new FormData(form).forEach((waarde, naam) => params.append(naam, String(waarde)));
    return params;
  };

  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.hasAttribute('data-aurea-wagen-code')) {
        e.preventDefault();
        codeToepassen(form);
        return;
      }
      const actie = form.getAttribute('action') || '';
      if (!/\/cart\/add/.test(actie)) return;
      e.preventDefault();
      const knop = e.submitter || form.querySelector('[type="submit"]');
      bezig(knop, true);
      (async () => {
        try {
          const r = await fetch(actie.replace(/\.js$/, '') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
            body: formulierData(form),
          });
          if (!r.ok) {
            const j = await r.json().catch(() => ({}));
            melding(j.description || j.message || 'Toevoegen is niet gelukt.');
            return;
          }
          await vernieuw();
          open();
        } catch (fout) {
          melding('Toevoegen is niet gelukt. Probeer het nog eens.');
          console.warn('[aurea-wagen]', fout);
        } finally {
          bezig(knop, false);
        }
      })();
    },
    true
  );

  document.addEventListener('click', (e) => {
    const doel = e.target instanceof Element ? e.target : null;
    if (!doel) return;

    if (doel.closest('[data-aurea-wagen-sluit]')) {
      e.preventDefault();
      sluit();
      return;
    }

    // Het mandje in de header: in Horizon een link naar /cart of een knop voor de oude lade (#cart-drawer).
    const mandje = doel.closest('a.action__cart, [aria-controls="cart-drawer"], a[href$="/cart"].header-actions__action');
    if (mandje && lade()) {
      e.preventDefault();
      vernieuw().catch(() => {});
      open();
      return;
    }

    const aantal = doel.closest('[data-aurea-wagen-aantal]');
    if (aantal) {
      e.preventDefault();
      const key = aantal.getAttribute('data-aurea-wagen-aantal');
      const naar = parseInt(aantal.getAttribute('data-naar') || '0', 10);
      const regel = aantal.closest('[data-aurea-wagen-regel]');
      bezig(regel, true);
      post('/cart/change.js', { id: key, quantity: Math.max(0, naar) })
        .then(() => vernieuw())
        .catch((fout) => {
          bezig(regel, false);
          melding('Aanpassen is niet gelukt.');
          console.warn('[aurea-wagen]', fout);
        });
      return;
    }

    // Kleur kiezen in het aanbod "Tweede horloge": foto, link en de variant van de knop Toevoegen wisselen mee.
    const kleur = doel.closest('[data-aurea-wagen-kleur]');
    if (kleur) {
      e.preventDefault();
      const kaart = kleur.closest('[data-aurea-wagen-tweede]');
      if (!kaart) return;
      kaart.querySelectorAll('[data-aurea-wagen-kleur]').forEach((k) => {
        const aan = k === kleur;
        k.classList.toggle('is-gekozen', aan);
        k.setAttribute('aria-pressed', aan ? 'true' : 'false');
      });
      const beeld = kaart.querySelector('[data-aurea-wagen-tweede-beeld]');
      if (beeld && kleur.dataset.beeld) {
        beeld.removeAttribute('srcset');
        beeld.src = kleur.dataset.beeld;
      }
      const link = kaart.querySelector('[data-aurea-wagen-tweede-link]');
      if (link && kleur.dataset.url) link.setAttribute('href', kleur.dataset.url);
      const knop = kaart.querySelector('[data-aurea-wagen-toevoegen]');
      if (knop) knop.setAttribute('data-aurea-wagen-toevoegen', kleur.getAttribute('data-aurea-wagen-kleur') || '');
      return;
    }

    const toevoegen = doel.closest('[data-aurea-wagen-toevoegen]');
    if (toevoegen) {
      e.preventDefault();
      const id = parseInt(toevoegen.getAttribute('data-aurea-wagen-toevoegen') || '0', 10);
      bezig(toevoegen, true);
      post('/cart/add.js', { items: [{ id, quantity: 1 }] })
        .then((r) => {
          if (!r.ok) throw new Error('add ' + r.status);
          return vernieuw();
        })
        .catch((fout) => {
          bezig(toevoegen, false);
          melding('Toevoegen is niet gelukt.');
          console.warn('[aurea-wagen]', fout);
        });
      return;
    }

    const weg = doel.closest('[data-aurea-wagen-code-weg]');
    if (weg) {
      e.preventDefault();
      const code = weg.getAttribute('data-aurea-wagen-code-weg') || '';
      const rest = huidigeCodes().filter((c) => c.toLowerCase() !== code.toLowerCase());
      bezig(weg.closest('.aurea-wagen__pil'), true);
      post('/cart/update.js', { discount: rest.join(',') })
        .then(() => vernieuw())
        .catch(() => melding('Code weghalen is niet gelukt.'));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen()) sluit();
  });

  window.aureaWagen = { open, sluit, vernieuw };
})();
